import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged 
} from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Sign up normal user
  const signup = async (email, password) => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    // Create a document for the user with default 'user' role
    await setDoc(doc(db, "users", userCredential.user.uid), {
      email: email,
      role: 'user',
      createdAt: new Date()
    });
    return userCredential.user;
  };

  // Log in user
  const login = async (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  // Sign out user
  const logout = () => {
    return signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      console.log("Auth State Changed! User detected:", user ? user.email : "None");
      
      // FIRE THE RENDER INSTANTLY! DO NOT WAIT FOR THE DATABASE.
      // This guarantees the page never goes blank.
      if (user) {
        setCurrentUser({ ...user, role: 'user' });
      } else {
        setCurrentUser(null);
      }
      setLoading(false); 
      
      if (user) {
        try {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);
          
          if (docSnap.exists()) {
            console.log("Found user profile in database!");
            const userData = docSnap.data();
            setCurrentUser(prevUser => ({ ...prevUser, ...userData }));
          } else {
            console.log("No profile found - making default");
          }
        } catch (error) {
          console.error("Database connection blocked/failed:", error);
        }
      }
    });

    return unsubscribe; // Cleanup subscription
  }, []);

  const value = {
    currentUser,
    signup,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
